/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames
     */
    AppId: string;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGamesToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsFacebookGames | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

